import {customTheme} from "./blockly_theme";

require("./vendor.js");
require("./prototypes.js");
import DatasetListPage from "./pages/datasetList.js";
import DataPage from "./pages/data.js";
import DashboardPage from "./pages/dashboard.js";
import ProductDetailPage from "./pages/productDetail.js";


global.insightsApp = {
    pages: {
        ui: {
            DataPage,
            DatasetListPage,
            ProductDetailPage
        },
        insights: {
            DashboardPage
        },
    }
};


const dropdownElementList = document.querySelectorAll(".dropdown-toggle");
const dropdownList = [...dropdownElementList].map(
    (dropdownToggleEl) => new bootstrap.Dropdown(dropdownToggleEl)
);
$("select").select2({
    placeholder: "Please select",
    theme: "bootstrap-5",
    allowClear: true,
});

